import { render } from "./WorkTable.vue?vue&type=template&id=33bca8f6"
import script from "./WorkTable.vue?vue&type=script&lang=js"
export * from "./WorkTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/calp.io_v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__